import { AlertCircle } from "lucide-react";

export function ConfigNeeded({ title = "Configuration nécessaire", children, testid = "config-needed" }) {
  return (
    <div data-testid={testid} className="bg-amber-50 border border-amber-200 rounded-xl p-6 flex items-start gap-4">
      <div className="w-10 h-10 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center shrink-0">
        <AlertCircle className="w-5 h-5 text-amber-600" />
      </div>
      <div className="min-w-0">
        <div className="font-heading font-semibold text-slate-900">{title}</div>
        <div className="text-sm text-slate-600 mt-1">{children}</div>
      </div>
    </div>
  );
}
